var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<layout-container direction=\"row\">\n<layout-content grow=\"true\">\n<capture-map center=\"mapViewCtrl.center\" class=\"pages-mapview-map\"></capture-map>\n</layout-content>\n<layout-content class=\"pages-mapview-captures\">\n<scroll class=\"pages-mapview-captures-scroll\">\n<gallery-item class=\"pages-mapview-capture\" notdraggable notselectable ng-repeat=\"capture in mapViewCtrl.getSelectedCaptures()\" capture=\"capture\" scroll-visibility visible-event=\"SHOULD_LOAD\">\n</gallery-item>\n</scroll>\n</layout-content>\n</layout-container>\n";
var id1="map.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/templates/map.html
// module id = 431
// module chunks = 0